// src/pages/DoctorsOverview/components/ClinicTable.js
import React, { useEffect } from "react";
import { Table, Button, Space, Modal, message } from "antd";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import {
  selectClinicsDetails,
  selectIsClinicModalOpen,
} from "../DoctorsSelectors";
import {
  fetchClinicsDetails,
  fetchClinicsList,
  removeClinic,
} from "../DoctorsThunk";
import { openClinicModal } from "../DoctorsSlice";
import ClinicModal from "./ClinicModal";
// import { errorBarDefaultProps } from "recharts/types/cartesian/ErrorBar";

const { confirm } = Modal;

const ClinicTable = () => {
  const dispatch = useDispatch();
  const clinics = useSelector(selectClinicsDetails);
  const isModalOpen = useSelector(selectIsClinicModalOpen);

  useEffect(() => {
    dispatch(fetchClinicsDetails());
    dispatch(fetchClinicsList());
  }, [dispatch]);

  const handleEdit = (record) => {
    dispatch(openClinicModal(record));
  };

  const handleDelete = (record) => {
    confirm({
      title: "Are you sure delete this clinic?",
      onOk: async () => {
        try {
          await dispatch(removeClinic(record.clinic_id)).unwrap();
          message.success("Clinic deleted successfully");
          dispatch(fetchClinicsList());
          dispatch(fetchClinicsDetails());
        } catch (err) {          
          message.error(err?.message|| err || "Delete failed");
        }
      },
    });
  };

  const columns = [
    { title: "No.", key: "idx", render: (_, __, idx) => idx + 1 },
    { title: "Clinic Name", dataIndex: "clinic_name", key: "clinic_name" },
    { title: "Location", dataIndex: "location_name", key: "location_name" },
    { title: "Phone No", dataIndex: "phone_no", key: "phone_no" },
    { title: "Total Doctors", dataIndex: "total_doctors", key: "total_doctors" },
    { title: "Total", dataIndex: "total_clinic_sales", key: "total_clinic_sales", render: v => Number(v).toFixed(2) },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Space>
          <Button type="link" icon={<EditOutlined />} onClick={() => handleEdit(record)}>            
          </Button>
          <Button type="link" danger icon={<DeleteOutlined />} onClick={() => handleDelete(record)}>            
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 16 }}>
        <Button type="primary" onClick={() => dispatch(openClinicModal(null))}>
          + New Clinic
        </Button>
      </div>

      <Table
        columns={columns}
        dataSource={clinics}
        rowKey={(r) => r.clinic_id || Math.random()}
        pagination={{ pageSize: 10 }}
        scroll={{ x: "max-content" }}
      />

      {isModalOpen && <ClinicModal />}
    </div>
  );
};

export default ClinicTable;
